import styled from "styled-components";
import { makeStyles } from '@mui/styles';

export const PlayerCardData = styled.div`
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.playerCardBorderColor};
    background: ${({ theme }) => theme.playerContentBackground};
    padding: 32px;
`;

// export const PlayerAvatar = styled.img<{ backgroundImage?: string, isClub?: boolean }>`
//     draggable: ${true};
//     border: ${({ theme, isClub }) => isClub ? 'none' : `1.5px solid ${theme.borderColor}`};    
//     //background: url(${props => props.backgroundImage}) lightgray 50% / cover no-repeat;
//     background: ${({ isClub, backgroundImage }) =>
//         isClub ? 'none' : `url(${backgroundImage}) lightgray 50% / cover no-repeat`};
//     border-radius: ${({ isClub }) => (isClub ? '0' : '50%')};
// `;

export const PlayerAvatar = styled.img.attrs(() => ({
  draggable: true, // make it draggable by default
}))<{
  backgroundImage?: string;
  isClub?: boolean;
}>`
  border: ${({ theme, isClub }) =>
    isClub ? "none" : `1.5px solid ${theme.borderColor}`};
  background: ${({ isClub, backgroundImage }) =>
    isClub
      ? "none"
      : `url(${backgroundImage}) lightgray 50% / cover no-repeat`};
  border-radius: ${({ isClub }) => (isClub ? "0" : "50%")};
`;


export const PlayerName = styled.span`
    color: ${({ theme }) => theme.playerColor};  
`;

export const PlayerNumber = styled.span`
    color: ${({ theme }) => theme.NumberColor};        
`;

export const FamilyName = styled.span`
    color: ${({ theme }) => theme.playerColor};
`;

export const PlayerSmallData = styled.div`
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.playerDataBorder};
    padding: 8px;
    display : flex;
    align-items : center;
    gap : 10px;
    min-height : 60%;
    height: 30px;
`;

export const PlayerSmallDataText = styled.span<{ theme: string }>`
    color: ${({ theme }) => theme.playerDataTextColor};
`;

export const PlayerClubInfoData = styled.div<{ country?: string }>`
    border: 1px solid ${({ theme, country }) => country ? 'none' : theme.playerDataBorder};
`;

export const PlayerSystemFitData = styled.div`    
    // background: ${({ theme }) => theme.systemFitBackground};
    border: 1px solid ${({ theme }) => theme.systemFitBorder};    
`;

export const PlayerLargeDataText = styled.span`
    color: ${({ theme }) => theme.NumberColor};
`;

export const PlayerLargeDataValue = styled.span`
    color: ${({ theme }) => theme.PlayerDataValueColor};
`;

export const PlayerSystemFitDataValue = styled.span`
    color: ${({ theme }) => theme.systemFitDataColor};
`;

export const PlayerContent = styled.div`
    width: 100%;
    //height: 5139px;
    padding-bottom: 20px;
    background: ${({ theme }) => theme.playerContentBackground};
`;

export const PlayerClubCountryInfoData = styled.div<{ displayborder?: boolean }>`
min-width : fit-content;
    display: flex;
    // padding: 12px;
    align-items: center;
    gap: 12px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.playerDataBorder};
    // min-height: 65px;

    .country-image {
        border : 1px solid ${({ theme, displayborder }) => displayborder ? theme.imageBorderColor : 'transparent'};
    }
    &.club-data:hover {
        background: ${({ theme }) => theme.playerContentBackground};
    }
    &.resuls-club-data:hover {
        background: ${({ theme }) => theme.secondaryButtonBackground};
    }
`;

export const useStyles = makeStyles(() => ({
    badgeGreen: {
        backgroundColor: '#00D1A8',
        marginLeft: '2px',
        marginRight: '17px'
    },
}));